import * as React from "react";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import { Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

interface IProps {
    message: string;
}

export const RequestNoContentReport: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <MuiMessageBox
            variant="warning"
            message={
                <>
                    <Typography variant="h5">{t("Components.AxiosHandler.RequestNoContentTitle")}</Typography>
                    <Typography variant="subtitle1">{props.message}</Typography>
                </>
            }
        />
    );
};